<template>
  <router-view @retrigger-search="retriggerSearchHandler" />
  <LoopCookieBanner v-if="loopCookieBannerEnabled" />
</template>

<script>
import { mapGetters } from 'vuex'
import { initSearchClient, searchAllIndexes } from '@/helpers/search'
import { useGTM } from '@/composables/gtm'
import { useTracking } from '@/composables/tracking'
import { useLoopCookieBanner } from '@/composables/cookie-banner'
import { defineAsyncComponent } from 'vue'

export default {
  setup(){
    useGTM()
    useTracking()

    const {isEnabled: loopCookieBannerEnabled} = useLoopCookieBanner()

    return {
      loopCookieBannerEnabled,
    }

  },
  components: {
    LoopCookieBanner: defineAsyncComponent(() => import('@/components/LoopCookieBanner.vue')),
  },
  async mounted() {
    // if (this.currentLanguage) {
    //   this.$i18n.locale = this.currentLanguage
    // } else {
    //   if (navigator.language.includes('de')) {
    //     this.$store.commit('setCurrentLanguage', 'de')
    //     this.$i18n.locale = 'de'
    //   } else {
    //     this.$store.commit('setCurrentLanguage', 'en')
    //     this.$i18n.locale = 'en'
    //   }
    // }

    if (this.user) {
      this.$store.dispatch('userValidate')

      // initialise algolia and indexes on every reload
      await this.$store.dispatch('getKeyAndIndexes')
      this.initialiseSearch()
    }

    window.addEventListener('resize', this.updateIsTablet, {passive: true})
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIsTablet)
  },
  computed: {
    ...mapGetters(['currentLanguage', 'user', 'searchClient']),
  },
  watch: {
    user() {
      if (this.user) {
        this.$store.dispatch('getKeyAndIndexes')
      } else {
        this.resetStore()
      }
    },
    searchClient() {
      if (this.searchClient) this.initialiseSearch()
    },
  },
  methods: {
    initialiseSearch() {
      initSearchClient(this.searchClient)
      searchAllIndexes()
    },
    resetStore() {
      this.$store.commit('clearAllDropdowns')
    },
    retriggerSearchHandler() {
      searchAllIndexes()
    },
    updateIsTablet() {
      this.$store.commit('setIsTablet', window.innerWidth <= 768)
    },
  },
}
</script>
